import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-fda81634"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" 选择文件 ");

var _hoisted_2 = {
  class: "el-upload__tip"
};
var _hoisted_3 = {
  class: "tipsLine"
};
var _hoisted_4 = {
  class: "tiptext"
};
var _hoisted_5 = {
  class: "tipsLine"
};
var _hoisted_6 = {
  class: "tiptext"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_warning_filled = _resolveComponent("warning-filled");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_upload = _resolveComponent("el-upload");

  return _openBlock(), _createBlock(_component_el_upload, {
    class: "upload-demo",
    action: "",
    "http-request": _ctx.request,
    multiple: "",
    limit: _ctx.limit,
    "file-list": _ctx.fileList,
    "on-remove": _ctx.handleRemove,
    "on-preview": _ctx.handleProview,
    accept: _ctx.accept,
    "before-upload": _ctx.beforeAvatarUpload,
    "on-exceed": _ctx.onExceed
  }, {
    tip: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_warning_filled)];
        }),
        _: 1
      }), _createElementVNode("span", _hoisted_4, " 仅支持上传" + _toDisplayString(_ctx.acceptText) + "格式的文件", 1)]), _withDirectives(_createElementVNode("p", _hoisted_5, [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_warning_filled)];
        }),
        _: 1
      }), _createElementVNode("span", _hoisted_6, " 最多上传" + _toDisplayString(_ctx.limit) + "个文件", 1)], 512), [[_vShow, _ctx.limit < 1000000000]])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["http-request", "limit", "file-list", "on-remove", "on-preview", "accept", "before-upload", "on-exceed"]);
}